<template>
  <b-overlay :show="loading || !labData">
    <validation-observer ref="labForm" #default="{invalid}">
      <div class="flex-div">
        <b-button
          v-if="can('labs:CanApprove')"
          block
          type="submit"
          class="mb-5 mx-2 approve-btn"
          variant="success" 
          style="width: 150px"
          :disabled="loading || labData.status === 'approved'"
          @click="approveLab(labData.id)"
        >
          <feather-icon icon="UserCheckIcon" />
          <span class="align-middle ml-50">Approve</span>
        </b-button>

        <b-button
          v-if="can('labs:CanDecline')"
          block
          type="submit"
          class="mb-5 mx-2 decline-btn"
          variant="danger"
          style="width: 150px"
          :disabled="loading || labData.status === 'declined' || labData.status === 'approved'"
          @click="declineLab(labData.id)"
        >
          <feather-icon icon="UserXIcon" />
          <span class="align-middle ml-50">Decline</span>
        </b-button>
      </div>
      
      <b-form v-if="labData" ref="form" @submit.prevent="updateLab">
        <b-row>
          <b-col cols="12" xl="6" md="6">
            <b-card no-body>
              <div class="logo-wrapper">
                <div>
                  <b-media class="">
                    <b-avatar ref="previewEl" badge-variant="transparent" :src="avatarPath" :text="avatarText(`${labData.facility_details.lab_name} ${labData.facility_details.lab_name}`)" :variant="`light-${resolveStatusVariant(getLoanStatusTextForClient(getValueFromSource(labData, 'status')))}`" size="10rem" class="square-avatar">
                      <template #badge>
                        <b-button variant="primary" class="btn-icon rounded-circle" @click="$refs.avatar.$el.childNodes[0].click()">
                          <feather-icon icon="CameraIcon" />
                        </b-button>
                      </template>
                    </b-avatar>
                  </b-media>
                  <div>
                    <b-form-file v-show="false" ref="avatar" accept="image/*" placeholder="" no-drop @input="onImageRenderer" />
                  </div>
                </div>
              </div>
              <b-card-body class="pt-2">
                <b-form-group label="Lab Name" label-for="lab_name">
                  <validation-provider
                    #default="{ errors }"
                    name="Lab name"
                    rules="required"
                  >
                    <b-form-input
                      id="lab_name"
                      v-model="labData.facility_details.lab_name"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-card-body>

              <b-card-body class="pt-0">
                <b-form-group label="Lab Phone" label-for="lab_phone">
                  <validation-provider
                    #default="{ errors }"
                    name="Lab phone"
                    rules="required"
                    vid="lab_phone"
                  >
                    <b-form-input
                      id="lab_phone"
                      v-model="labData.facility_details.lab_phone"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-card-body>

              <b-card-body class="pt-0">
                <b-form-group label="Lab Email" label-for="lab_email">
                  <validation-provider
                    #default="{ errors }"
                    name="Lab Email"
                    rules=""
                  >
                    <b-form-input
                      id="lab_email"
                      v-model="labData.facility_details.lab_email"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-card-body>
              
              <b-card-body class="pt-0">
                <b-form-group label="Lab Address" label-for="lab_address">
                  <validation-provider
                    #default="{ errors }"
                    name="Lab Address"
                    rules=""
                  >
                    <b-form-input
                      id="lab_address"
                      v-model="labData.facility_details.lab_address"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-card-body>

              <b-card-body class="pt-0">
                <b-form-group label="Lab Website" label-for="lab_website">
                  <validation-provider
                    #default="{ errors }"
                    name="Lab Website"
                    rules=""
                  >
                    <b-form-input
                      id="lab_website"
                      v-model="labData.facility_details.lab_website"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-card-body>

            <b-button
              block
              type="submit"
              class="mb-5 mx-2"
              variant="primary"
              style="width: 150px"
              :disabled="invalid || loading"
            >
              Update
            </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
      <b-row>
      </b-row>
    </validation-observer>
  </b-overlay> 
</template>

<script>
  import { get } from "lodash";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import { 
    BAlert, 
    BAvatar, 
    BBadge, 
    BImg, 
    BCard, 
    BCol, 
    BLink, 
    BRow, 
    BCardImg, 
    BFormFile,  
    BMedia,
    BOverlay,
    BDropdown,
    BDropdownItem,
    BCardBody,
    BButton,
    BFormGroup,
    BForm,
    BFormInput, } from "bootstrap-vue"
  import useJwt from "@/auth/jwt/useJwt";
  import VueEasyLightbox from 'vue-easy-lightbox';
  import ListTable from "@core/components/ListTable/ListTable.vue";
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
  // import {
  // required,
  // email
  // } from '@validations'

  export default {
    components: {
      ListTable,
      VueEasyLightbox,
      BAlert, 
      BAvatar, 
      BBadge, 
      BImg, 
      BCard, 
      BCol, 
      BLink, 
      BRow, 
      BCardImg,   
      BMedia,
      BOverlay,
      BDropdown,
      BDropdownItem,
      BCardBody,
      BFormFile,
      BButton,
      BFormGroup,
      BForm,
      BFormInput,
      // validations
      ValidationProvider,
      ValidationObserver,
  },
    directives: {},
    data(){
      return {
        loading: false,
  
        labData: null,
        avatarPath: "",
        updatedImage: null,
      }
    },
    created() {
      this.fetchLabData();
    },
    methods: {
      async approveLab(lab_id) {
        try {
        this.loading = true;

        if (!this.can(`labs:CanApprove`)) {
          return
        }

        const activateConfirmation = await this.$swal({
          title: 'Approve this Lab?',
          text: "Do you want to approve this lab?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, proceed!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })

        if (!activateConfirmation.value){
          return;
        }

        await useJwt.mainService.labs.approve(lab_id, { status: "approved" });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Lab approved successfully`
          },
        });

        this.fetchLabData()
      } catch (error){
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
      },
      async declineLab(lab_id) {
        try {
        this.loading = true;

        if (!this.can(`labs:CanDecline`)) {
          return
        }

        const activateConfirmation = await this.$swal({
          title: 'Decline this Lab?',
          text: "Do you want to decline this lab?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, proceed!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })

        if (!activateConfirmation.value){
          return;
        }

        await useJwt.mainService.labs.decline(lab_id, { status: "declined" });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Lab declined successfully`
          },
        });

        this.fetchLabData()
      } catch (error){
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
      },
      async updateLab(){
      try {
        this.loading = true
        this.error = "";

        const success = await this.$refs.labForm.validate();
        if (!success) {
          throw new Error("Please check and make sure all fields are valid");
        }

        const formData = new FormData();

        formData.append("lab_name", this.labData.facility_details.lab_name);
        formData.append("lab_phone", this.labData.facility_details.lab_phone);
        formData.append("lab_email", this.labData.facility_details.lab_email);

        formData.append("lab_address", this.labData.facility_details.lab_address);
        formData.append("lab_website", this.labData.facility_details.lab_website);

        if (this.updatedImage) {
        formData.append("avatar", this.updatedImage);
        }

        const { id } = this.labData
        await this.useJwt().mainService.labs.update(id, formData);

        if (this.updatedImage){
          this.updatedImage = null;
        }

        this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: `Update successful`,
          icon: 'CoffeeIcon',
          variant: 'success',
          text: `You have successfully updated your lab informations.`,
        },
        });
      } catch (error) {
        console.log(error);
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.error = error_message
      } finally {
        this.loading = false;
      }
      },
      async fetchLabData(){
        try {
          this.loading = true;
          const { id } = this.$route.params;
  
          const response = await this.useJwt().mainService.labs.fetch(id);
          this.labData = get(response, 'data.data');
          if (this.labData.facility_details.avatar.path) {
            this.avatarPath = this.labData.facility_details.avatar.path
          }
        } catch (error){
          this.labData = undefined;
  
          const error_message = get(error, "response.data.message") || error.message
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: error_message
            },
          });
        } finally {
          this.loading = false
        }
      },
      onImageRenderer(file) {
        const reader = new FileReader()

        reader.addEventListener(
          'load',
          () => {
            this.avatarPath = reader.result
            this.updatedImage = file;
          },
          false,
        )

        if (file) {
        reader.readAsDataURL(file)
        }
      },
      onRefreshRef(ref){
        if (this.$refs[ref]){
          this.$refs[ref].fetchAllData();
        }
      }
    }
  }
</script>
  
<style lang="scss">
  small {
    font-size: 10px;
  }

  .flex-div {
    display: flex;
    align-items: center;
    margin-bottom: -20px !important;
  }

  .approve-btn {
    margin-top: 8px !important;
  }

  .square-avatar {
    border-radius: 0 !important; 
  }

  .logo-wrapper {
    margin-top: 20px;
    text-align: center
  }
</style>
